<template>
  <div class="col-lg-4 col-md-4 col-12 detail-left">
    <div class="item-class display-flex">
      <div class="info-left display-flex">
        <img src="@/assets/img/icon-list.png" alt />
        <div class="info-class text-left">
          <h2
            v-if="getCourseDetail && getCourseDetail.name"
            class="primary-color font-sanpro-semibold font-size-16"
          >{{getCourseDetail.name}}</h2>
          <h3
            v-if="getCourseDetail && getCourseDetail.name"
            class="secondary-color-txt font-family-Semibold font-size-14"
          >{{getCourseDetail.school}}</h3>
          <h3
            v-if="getCourseDetail && getCourseDetail.name"
            class="secondary-color-txt font-family-Semibold font-size-14"
          >
            Mã lớp:
            <router-link
              class="primary-color font-sanpro-semibold font-size-14"
              :to="{name:'ViewCodeClass',params:{classId:getCourseDetail.classSchoolSubjectId}}"
            >{{getCourseDetail.code}}</router-link>
          </h3>
        </div>
      </div>
    </div>
    <div class="status-join display-flex">
      <div class="form-group select-status">
        <select class="form-control" id="status" @change="leaveClass" v-model="selectleaveClass">
          <option value="0">Đã tham gia</option>
          <option value="1">Rời lớp</option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="dropdown dropdown-account">
        <button
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          class="dropdown-toggle"
        >
          <i class="fas fa-ellipsis-h"></i>
        </button>
        <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
          <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
          <a href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
          <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
        </div>
      </div>
    </div>
    <!-- <InfoClassLeft /> -->
    <div class="menu-tabs">
      <router-link
        :to="{name: 'ViewDetailSubject',params:{id :classSchoolSubjectId}}"
        :class="{'active': this.$route.name=='ViewDetailSubject' || this.$route.name=='ViewDetailSubjectContent'}"
      >Nội dung môn học</router-link>
      <router-link
        :to="{name: 'viewDetailDiscuss',params:{id :classSchoolSubjectId}}"
        :class="{'active': this.$route.name=='viewDetailDiscuss'}"
      >Thảo luận</router-link>
      <router-link
        :to="{name: 'ViewdetailCalendar',params:{id :classSchoolSubjectId}}"
        :class="{'active': this.$route.name=='ViewdetailCalendar'}"
      >Lịch</router-link>
      <router-link
        :to="{name: 'ViewDetailDoccument'}"
        :class="{'active': this.$route.name=='ViewDetailDoccument'}"
      >Tài liệu</router-link>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import { apiLeaveClass } from "../../_api";
// import ContentSubject from "../_components/detail/ContentSubject"
// import Discuss from "../_components/detail/Discuss"
// import InfoClassLeft from "../_components/detail/InfoClassLeft"
export default {
  name: "DetailsubjectLeft",
  data() {
    return {
      selectleaveClass: 0,
      classSchoolSubjectId: this.$route.params.id
    };
  },
  computed: {
    ...mapGetters({
      getParamListSchool: STORE_KEY + "/getParamListSchool",
      // classLists: STORE_KEY + "/classLists",
      getCourseDetail: STORE_KEY + "/getCourseDetail"
    })
  },
  mounted() {
    // console.log("2222222222222222222",this.$route.name)
    // this.actionGetListSubjectInWeek();
    // this.actionGetListClass();
    // this.actionGetCourseDetail(this.classSchoolSubjectId)
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [ "actionGetListClass"]),
    leaveClass() {
      if (this.selectleaveClass == 1) {
        apiLeaveClass({ classSchoolSubjectId: this.classSchoolSubjectId }).then(
          res => {
            if (res.status === "success") {
              this.actionGetListClass(this.getParamListSchool);
              this.$router.push({
                name: "ViewListClass"
              });
              this.$toast.success("Đã rời lớp");
            }
          }
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// .detail-right{
//     margin:49px 0 100px 0;

// }
.dropdown-account {
  margin-left: 10px;
}
.dropdown button {
  width: 30px;
  background: #f3f6fb;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: #f3f6fb;
}
.dropdown button:focus {
  background: #f3f6fb !important;
  color: #124abe;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 425px) {
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
  .list-class .add-search {
    display: block;
    .btns {
      margin-bottom: 20px;
    }
  }
}
</style>